const UiRating = () => {
  return(<></>);
};
export default UiRating;
